gsap.from(".text-reveal", {
  scrollTrigger: {
    trigger: ".text-reveal",
    start: "top 80%",
  },
  y: 120,
  skewY: 6,
  opacity: 0,
  duration: 1.2,
  ease: "power4.out"
});

gsap.from(".img-mask img", {
  scrollTrigger: ".img-mask",
  scale: 1.3,
  y: 120,
  duration: 1.2,
  ease: "power3.out"
});


gsap.utils.toArray(".wishlist-btn").forEach(btn => {
  btn.addEventListener("click", () => {
    gsap.fromTo(btn, 
      { scale: 1 },
      { scale: 1.3, duration: 0.25, yoyo: true, repeat: 1, ease: "power1.out" }
    );
  });
});


gsap.registerPlugin(ScrollTrigger);

// SECTION BLUR + REVEAL
gsap.from(".blur-reveal", {
  scrollTrigger: {
    trigger: ".blur-reveal",
    start: "top 75%",
    toggleActions: "play none none reverse"
  },
  filter: "blur(12px)",
  y: 80,
  opacity: 0,
  duration: 1,
  ease: "power3.out"
});

// HEADING ANIMATION
gsap.from(".match-head h2", {
  scrollTrigger: {
    trigger: ".match-head",
    start: "top 80%"
  },
  y: 40,
  opacity: 0,
  duration: 0.8,
  ease: "power3.out"
});

// CARDS STAGGER ANIMATION
gsap.from(".match-main", {
  scrollTrigger: {
    trigger: ".match",
    start: "top 75%"
  },
  y: 60,
  opacity: 0,
  scale: 0.95,
  duration: 0.8,
  stagger: 0.2,
  ease: "power3.out"
});

// IMAGE PARALLAX FEEL
gsap.to(".match-main img", {
  yPercent: -10,
  ease: "none",
  scrollTrigger: {
    trigger: ".match",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  }
});

// BUTTON MICRO INTERACTION
gsap.utils.toArray(".match-main").forEach(card => {
  card.addEventListener("mouseenter", () => {
    gsap.to(card, {
      y: -8,
      duration: 0.3,
      ease: "power2.out"
    });
  });

  card.addEventListener("mouseleave", () => {
    gsap.to(card, {
      y: 0,
      duration: 0.3,
      ease: "power2.out"
    });
  });
});



gsap.registerPlugin(ScrollTrigger);

let tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".story",
    start: "top 70%",
    end: "bottom center",
    scrub: true
  }
});

tl.from(".story-text", {
    x: -120,
    opacity: 0,
    duration: 1
})
.from(".story-social", {
    x: 120,
    opacity: 0,
    duration: 1
}, "<")
.from(".social-list li", {
    y: 60,
    opacity: 0,
    stagger: 0.15,
    duration: 0.6
}, "-=0.5");


gsap.registerPlugin(ScrollTrigger);

/* ===== TESTIMONIAL TIMELINE ===== */
let testiTL = gsap.timeline({
  scrollTrigger: {
    trigger: ".testi-story",
    start: "top 70%",
    end: "bottom center",
    scrub: false,
    once: true
  }
});

testiTL
.from(".testi-title h2", {
  y: 80,
  opacity: 0,
  duration: 1,
  ease: "power3.out"
})
.from(".testi-card", {
  y: 100,
  opacity: 0,
  scale: 0.95,
  stagger: 0.2,
  duration: 0.8,
  ease: "power3.out"
}, "-=0.4")
.from(".testi-arrow", {
  opacity: 0,
  scale: 0,
  stagger: 0.15,
  duration: 0.4
}, "-=0.3");


gsap.registerPlugin(ScrollTrigger);

/* ===== BANNER MASTER TIMELINE ===== */
let bannerTL = gsap.timeline({
  defaults: { ease: "power4.out" }
});

/* Background image cinematic zoom */
bannerTL.from(".banner-img img", {
  scale: 1.25,
  opacity: 0,
  duration: 1.8
})

/* Sub heading */
.from(".banner-sub", {
  y: 30,
  opacity: 0,
  duration: 0.6
}, "-=1.2")

/* Main heading (hero text) */
.from(".banner-title", {
  y: 80,
  opacity: 0,
  duration: 1
}, "-=0.6")

/* Description */
.from(".banner-desc", {
  y: 40,
  opacity: 0,
  duration: 0.8
}, "-=0.6")

/* CTA Button */
.from(".banner-cta", {
  scale: 0.8,
  opacity: 1,
  duration: 0.6
}, "-=0.5");

gsap.utils.toArray(".web-btn").forEach(btn => {
  btn.addEventListener("mouseenter", () => {
    gsap.to(btn, { scale: 1.05, duration: 0.3 });
  });
  btn.addEventListener("mouseleave", () => {
    gsap.to(btn, { scale: 1, duration: 0.3 });
  });
});

const words = [
  "CJ Creations.store",
  "Creative Living",
  "Smart Shopping",
  "Everyday Essentials"
];

let wordIndex = 0;
let charIndex = 0;
let isDeleting = false;
const typingSpeed = 90;
const deletingSpeed = 50;
const delayBetweenWords = 1200;

const typingElement = document.querySelector(".typing-text");

function typeEffect() {
  const currentWord = words[wordIndex];

  if (!isDeleting) {
    typingElement.textContent = currentWord.substring(0, charIndex + 1);
    charIndex++;
  } else {
    typingElement.textContent = currentWord.substring(0, charIndex - 1);
    charIndex--;
  }

  if (!isDeleting && charIndex === currentWord.length) {
    setTimeout(() => (isDeleting = true), delayBetweenWords);
  }

  if (isDeleting && charIndex === 0) {
    isDeleting = false;
    wordIndex = (wordIndex + 1) % words.length;
  }

  setTimeout(typeEffect, isDeleting ? deletingSpeed : typingSpeed);
}

/* GSAP fade-in for typing text */
gsap.from(".typing-text", {
  opacity: 1,
  duration: 1,
  delay: 0.6
});

typeEffect();


gsap.registerPlugin(ScrollTrigger);

/* ===== SHOP SECTION SCROLL ANIMATION ===== */
let shopTL = gsap.timeline({
  scrollTrigger: {
    trigger: ".shop-story",
    start: "top 75%",
    once: true
  }
});

/* Title reveal */
shopTL.from(".shop-title h2", {
  y: 60,
  opacity: 0,
  duration: 0.8,
  ease: "power3.out"
});

/* Cards stagger animation */
shopTL.from(".shop-card", {
  y: 120,
  opacity: 0,
  scale: 0.9,
  stagger: 0.2,
  duration: 0.9,
  ease: "power3.out"
}, "-=0.3");

const cursor = document.querySelector(".custom-cursor");

/* Cursor follow mouse */
window.addEventListener("mousemove", (e) => {
  gsap.to(cursor, {
    x: e.clientX,
    y: e.clientY,
    duration: 0.2,
    ease: "power2.out"
  });
});

/* Show cursor on hover */
gsap.utils.toArray(".shop-item-main").forEach(card => {

  card.addEventListener("mouseenter", () => {
    gsap.to(cursor, {
      scale: 1,
      duration: 0.3,
      ease: "power3.out"
    });

    gsap.to(card.querySelector("img"), {
      scale: 1.2,
      duration: 0.4
    });
  });

  card.addEventListener("mouseleave", () => {
    gsap.to(cursor, {
      scale: 0,
      duration: 0.3,
      ease: "power3.out"
    });

    gsap.to(card.querySelector("img"), {
      scale: 1,
      duration: 0.4
    });
  });
});


gsap.registerPlugin(ScrollTrigger);

let featTL = gsap.timeline({
  scrollTrigger: {
    trigger: ".featured-story",
    start: "top 70%",
    end: "bottom center",
    once: true
  }
});

/* Image cinematic reveal */
featTL.from(".feat-img img", {
  scale: 1.25,
  opacity: 1,
  duration: 1.4,
  ease: "power3.out"
})

/* Title */
.from(".feat-title", {
  x: -100,
  opacity: 0,
  duration: 0.8
}, "-=1.1")

/* Description */
.from(".feat-desc", {
  x: -80,
  opacity: 0,
  duration: 0.7
}, "-=0.6")

/* List items stagger */
.from(".feat-list li", {
  x: -60,
  opacity: 0,
  stagger: 0.15,
  duration: 0.5
}, "-=0.4")

/* Button pop */
.from(".feat-btn", {
  scale: 0.85,
  opacity: 0,
  duration: 0.4
}, "-=0.2");

gsap.to(".feat-img2 img", {
  y: -40,           // pixels use karo (safe)
  ease: "none",
  scrollTrigger: {
    trigger: ".featured-story",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  }
});

gsap.utils.toArray(".feat-list li").forEach(item => {
  item.addEventListener("mouseenter", () => {
    gsap.to(item, { x: 10, duration: 0.2 });
  });
  item.addEventListener("mouseleave", () => {
    gsap.to(item, { x: 0, duration: 0.2 });
  });
});

